// extracted by mini-css-extract-plugin
export default {"detailsDisclaimer":"_4c513067","textSizeAuctions":"_8c4f6e46","textSizePdpCheckout":"_bbbfa832"};